import { Route, Routes } from 'react-router-dom'

import EditPage from './screens/EditPage'

const ArtworkBuilderRoutes = () => (
  <Routes>
    <Route path="/tasks/:taskId/edit" element={<EditPage />} />
    <Route
      path="/orderItems/:orderItemId/artworks/:artworkId/pages/:artworkPageId"
      element={<EditPage />}
    />
  </Routes>
)

export default ArtworkBuilderRoutes
